module.exports = __webpack_public_path__ + "static/img/3.8e2a1bf2.png";